import { CAMPAGNE_STATUT_TEXTS } from '@common/config';
import { useCloseRefOnOuterClick } from '@common/hooks';
import { useCurrentCampagne } from '@common/hooks/campagne';
import { CampagneDto } from '@common/services';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import { SelectOption } from '../../form';

export const CampagneSelect = ({ campagnes, onYearChange }: CampagneSelectProps) => {
  const ref = useRef<HTMLDivElement>(null!);

  const { campagne } = useCurrentCampagne();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedYear, setSelectedYear] = useState<string | null>(null);

  useCloseRefOnOuterClick({ ref, setOpen: setIsOpen });

  useEffect(() => {
    if (!campagne) return;

    setSelectedYear(campagne.annee.toString());
  }, [campagne]);

  const options = useMemo<SelectOption[]>(() => campagnes.map(({ annee, statut }) => ({
    label: `campagne ${CAMPAGNE_STATUT_TEXTS[statut]} : ${annee}`,
    value: annee.toString(),
  })), [campagnes]);

  const handleSelect = (year) => {
    setSelectedYear(year);
    setIsOpen(false);
    onYearChange?.(Number(year));
  };

  return (
    <div className="relative w-full max-w-80" ref={ref}>
      <button onClick={() => setIsOpen(!isOpen)}
              style={{
                backgroundColor: '#FFFFFF',
                border: '2px solid #C7C7FA',
                color: 'var(--background-flat-blue-france)',
              }}
              className="w-full rounded-lg px-6 py-4 flex items-center justify-between transition-colors">
        <span className={'uppercase'}>{options.find(({ value }) => (value === selectedYear))?.label}</span>
        <RiArrowDownSLine className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {(isOpen) && (
        <div className="absolute w-full bg-white border-2 border-[#C7C7FA] rounded-lg shadow-lg overflow-hidden z-10">
          {options.map(({ value, label }, index) => (
            <button key={index}
                    onClick={() => handleSelect(value)}
                    style={{
                      color: (value === selectedYear) ? 'var(--background-flat-blue-france)' : '',
                      backgroundColor: (value === selectedYear) ? '#F1F1F9' : '#ffffff',
                    }}
                    className={`w-full text-left px-6 py-4`}>
              <span className={'uppercase'}>{label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export interface CampagneSelectProps {
  campagnes: Pick<CampagneDto, 'annee' | 'statut'>[];
  onYearChange?: (year: number) => void;
}